import { combineReducers } from 'redux';
import auth from './authReducer';
import report from './reportReducer';

const rootReducer = combineReducers({
  auth,
  report
});
export default rootReducer;
